import "core-js/modules/es6.number.parse-int";
import "core-js/modules/es6.number.constructor";
import _toConsumableArray from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/toConsumableArray";

var withPrefixPermission = function withPrefixPermission(prefix, permission, routes) {
  return routes.map(function (route) {
    route.path = prefix + route.path;
    route.meta = {
      Permission: permission
    };
    return route;
  });
};

var routes = [{
  path: "/",
  component: function component() {
    return import("layouts/LayoutFactory.vue");
  },
  children: [{
    path: "",
    component: function component() {
      return import("pages/Index.vue");
    },
    name: "home"
  }, {
    path: "/admin",
    component: function component() {
      return import("pages/AdminPage.vue");
    },
    name: "admin"
  }, {
    path: "/blank",
    component: function component() {
      return import("pages/BlankPage.vue");
    },
    name: "BlankPage"
  }, {
    path: "/dashboard",
    component: function component() {
      return import("pages/Dashboard.vue");
    },
    name: "dashboard"
  }, {
    path: "/MessageManager",
    component: function component() {
      return import("pages/MessageManager.vue");
    },
    name: "MessageManager"
  }, {
    path: "/emailTemplate/:id",
    component: function component() {
      return import("pages/email/emailTemplate.vue");
    },
    name: "Email"
  }, {
    path: "/emailTemplates",
    component: function component() {
      return import("pages/email/emailTemplateList.vue");
    },
    name: "EmailTemplates"
  }, {
    path: "/companies",
    component: function component() {
      return import("pages/ManagementCompanies/ManagementCompanies.vue");
    },
    name: "companies"
  }, {
    path: "/companies/merge",
    component: function component() {
      return import("pages/ManagementCompanies/MergeManagementCompanies.vue");
    },
    name: "merge-companies"
  }, {
    path: "/company/:isNew/:id",
    component: function component() {
      return import("pages/ManagementCompanies/ManagementCompany.vue");
    },
    name: "company",
    props: function props(route) {
      return {
        isNew: route.params.isNew == "true",
        id: Number(route.params.id)
      };
    }
  }, {
    path: "/ManagementFeeMax",
    component: function component() {
      return import("pages/admin/ManagementFeeMax.vue");
    },
    name: "ManagementFeeMax"
  }, {
    path: "/TCAP/:projectId/:periodDate",
    component: function component() {
      return import("pages/TCAP/TCAP.vue");
    },
    name: "TCAP"
  }, {
    path: "/TCAPAdmin/:projectId/:year/:quarter",
    component: function component() {
      return import("pages/TCAP/TCAPAdmin.vue");
    },
    name: "TCAPAdmin"
  }, {
    path: "/TCAPList/:id",
    component: function component() {
      return import("pages/TCAP/TCAPList.vue");
    },
    name: "TCAPList"
  }, {
    path: "/TCAPProjectList",
    component: function component() {
      return import("pages/TCAP/TCAPProjectList.vue");
    },
    name: "TCAPProjectList"
  }, {
    path: "/TCAPListAdmin",
    component: function component() {
      return import("pages/TCAP/TCAPListAdmin.vue");
    },
    name: "TCAPListAdmin"
  }, {
    path: "/TCAPAdminList",
    component: function component() {
      return import("pages/TCAP/TCAPAdminList.vue");
    },
    name: "TCAPAdminList"
  }, {
    path: "/NonComplianceList",
    component: function component() {
      return import("pages/NonCompliance/NonComplianceList.vue");
    },
    name: "NonComplianceList",
    props: function props(r) {
      return {
        projectIdfilter: r.params.projectIdfilter,
        propertyId: -1
      };
    }
  }, {
    path: "/VawaList",
    component: function component() {
      return import("pages/ProjectOccupancy/VawaList.vue");
    },
    name: "VawaList"
  }, {
    path: "/NonComplianceList/:propertyId",
    component: function component() {
      return import("pages/NonCompliance/NonComplianceList.vue");
    },
    name: "NonCompliancePropertyList",
    props: true
  }].concat(_toConsumableArray(withPrefixPermission("occupancy", "Occupancy", [{
    path: "/view/:projectId/:projectOccupancyId",
    component: function component() {
      return import("pages/ProjectOccupancy/ProjectOccupancy.vue");
    },
    name: "ProjectOccupancy",
    props: function props(r) {
      return {
        projectId: r.params.projectId,
        projectOccupancyId: r.params.projectOccupancyId,
        periodDate: r.params.periodDate
      };
    }
  }, {
    path: "/list/project/:id",
    component: function component() {
      return import("pages/ProjectOccupancy/ProjectOccupancyHistory.vue");
    },
    name: "ProjectOccupancyList"
  }, {
    path: "/list/:id",
    component: function component() {
      return import("pages/ProjectOccupancy/ProjectOccupancyList.vue");
    },
    name: "OccupancyList"
  }])), _toConsumableArray(withPrefixPermission("utilityAllowance", "Utility_Allowance", [{
    path: "/view/:projectId/:utilityAllowanceId",
    component: function component() {
      return import("pages/UtilityAllowance/UtilityAllowance.vue");
    },
    name: "UtilityAllowance",
    props: function props(r) {
      return {
        isComponent: r.params.isComponent,
        projectId: r.params.projectId,
        utilityAllowanceId: r.params.utilityAllowanceId,
        periodDate: r.params.periodDate
      };
    }
  }, {
    path: "/list/:id",
    component: function component() {
      return import("pages/UtilityAllowance/UtilityAllowanceList.vue");
    },
    name: "UtilityAllowanceList",
    meta: {
      Permission: "UtilityAllowance"
    }
  }, {
    path: "/list/project/:projectId",
    component: function component() {
      return import("pages/UtilityAllowance/UtilityAllowanceHistory.vue");
    },
    name: "UtilityAllowanceHistoryId",
    props: true
  }])), [{
    path: "/TaskMessengerExample",
    component: function component() {
      return import("pages/TaskMessengerExample.vue");
    },
    name: "TaskMessengerExample"
  }, {
    path: "/WatchList",
    component: function component() {
      return import("pages/WatchList/WatchListList.vue");
    },
    name: "WatchListList"
  }, {
    path: "/WatchList/:id",
    component: function component() {
      return import("pages/WatchList/WatchListView.vue");
    },
    name: "WatchListView",
    props: true
  }, {
    path: "/WatchListReports",
    component: function component() {
      return import("pages/WatchList/WatchListReports.vue");
    },
    name: "WatchListReportGenerator"
  }, {
    path: "/WatchList/new/:propertyId",
    component: function component() {
      return import("pages/WatchList/WatchListView.vue");
    },
    name: "NewWatchList",
    props: true
  }], _toConsumableArray(withPrefixPermission("afs", "AFS", [{
    path: "/view/:year/:propertyId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/AFSView.vue");
    },
    name: "AFSView",
    props: true
  }, {
    path: "/list/multi",
    component: function component() {
      return import("pages/AnnualFinancialStatement/AFSMultiPropertyList.vue");
    },
    name: "AFSMultiPropertyList",
    props: true
  }, {
    path: "/list/single/:propertyId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/AFSSinglePropertyList.vue");
    },
    name: "AFSSinglePropertyList",
    props: true
  }, {
    path: "/review/reportcard/:afsId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/ReportCard.vue");
    },
    name: "AFSSinglePropertyReportCard",
    props: true
  }, {
    path: "/review/list",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/List.vue");
    },
    name: "AFSReviewList",
    props: true
  }, {
    path: "/review/list/:propertyId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/List.vue");
    },
    name: "AFSReviewListWithProperty",
    props: true
  }, {
    path: "/review/surplus/:afsId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/SurplusCash.vue");
    },
    name: "AFSReviewSurplusList",
    props: true
  }, {
    path: "/review/computationdistribution/:afsId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/ComputationToDistributions.vue");
    },
    name: "AFSReviewDistributionList",
    props: true
  }, {
    path: "/review/budgetvsaudit/:afsId",
    component: function component() {
      return import("pages/AnnualFinancialStatement/review/BudgetVsAudit.vue");
    },
    name: "AFSReviewCompareList",
    props: true
  }])), _toConsumableArray(withPrefixPermission("DistributionRequest", "AFS", [{
    path: "/view/:requestId",
    component: function component() {
      return import("pages/DistributionRequest/DistributionRequestView.vue");
    },
    name: "DistributionRequestView",
    props: true
  }, {
    path: "/list/single/:propertyId",
    component: function component() {
      return import("pages/DistributionRequest/DistributionRequestSinglePropertyList.vue");
    },
    name: "DistributionRequestSinglePropertyList",
    props: true
  }, {
    path: "/review/:requestId",
    component: function component() {
      return import("pages/DistributionRequest/DistributionRequestReview.vue");
    },
    name: "DistributionRequestReview",
    props: true
  }, {
    path: "/review/list/year",
    component: function component() {
      return import("pages/DistributionRequest/DistributionRequestReviewList.vue");
    },
    name: "DistributionRequestReviewList",
    props: true
  }, {
    path: "/list/multi",
    component: function component() {
      return import("pages/DistributionRequest/DistributionRequestMultiPropertyList.vue");
    },
    name: "DistributionRequestMultiPropertyList",
    props: true
  }])), _toConsumableArray(withPrefixPermission("replacementReserve", "Replacement_Reserve", [{
    path: "/ReplacementReserve/:id/:projectId",
    component: function component() {
      return import("pages/ReplacementReserve/ReplacementReserve.vue");
    },
    name: "ReplacementReserve"
  }, {
    path: "/ReplacementReserveList/:projectId",
    component: function component() {
      return import("pages/ReplacementReserve/ReplacementReserveList.vue");
    },
    name: "ReplacementReserveList"
  }, {
    path: "/ReplacementReserveMultiNav",
    component: function component() {
      return import("pages/ReplacementReserve/ReplacementReserveMultiNav.vue");
    },
    name: "ReplacementReserveMultiNav"
  }, {
    path: "/R4rSuspensionRequest/create/:projectId",
    component: function component() {
      return import("pages/ReplacementReserve/R4rSuspensionRequest.vue");
    },
    name: "CreateSuspensionRequest",
    props: function props(r) {
      return {
        projectId: r.params.projectId,
        create: true
      };
    }
  }, {
    path: "/R4rSuspensionRequest/edit/:replacementReserveSuspensionId",
    component: function component() {
      return import("pages/ReplacementReserve/R4rSuspensionRequest.vue");
    },
    name: "EditSuspensionRequest",
    props: function props(r) {
      return {
        replacementReserveSuspensionId: r.params.replacementReserveSuspensionId
      };
    }
  }])), [{
    path: "/ManagementCompanyAssetCertificationApplication/create/:managementCompanyId",
    component: function component() {
      return import("pages/ManagementCompanies/ManagementCompanyAssetCertificationApplication.vue");
    },
    name: "CreateManagementCompanyAssetCertificationApplication",
    props: function props(r) {
      return {
        managementCompanyId: r.params.managementCompanyId,
        create: true
      };
    }
  }, {
    path: "/ManagementCompanyAssetCertificationApplication/edit/:managementCompanyAssetCertificationId",
    component: function component() {
      return import("pages/ManagementCompanies/ManagementCompanyAssetCertificationApplication.vue");
    },
    name: "EditManagementCompanyAssetCertificationApplication",
    props: function props(r) {
      return {
        managementCompanyAssetCertificationId: r.params.managementCompanyAssetCertificationId,
        create: false
      };
    }
  }, {
    path: "/ManagementCompanyAssetCertificationList/:managementCompanyId",
    component: function component() {
      return import("pages/ManagementCompanies/ManagementCompanyAssetCertificationList.vue");
    },
    name: "ManagementCompanyAssetCertificationList",
    props: function props(r) {
      return {
        managementCompanyId: r.params.managementCompanyId
      };
    }
  }], _toConsumableArray(withPrefixPermission("operatingReserve", "OperatingReserve", [{
    path: "/OperatingReserve/:id/:projectId",
    component: function component() {
      return import("pages/OperatingReserve/OperatingReserve.vue");
    },
    name: "OperatingReserve"
  }, {
    path: "/OperatingReserveList/:id",
    component: function component() {
      return import("pages/OperatingReserve/OperatingReserveList.vue");
    },
    name: "OperatingReserveList"
  }, {
    path: "/OperatingReserveMultiNav",
    component: function component() {
      return import("pages/OperatingReserve/OperatingReserveMultiNav.vue");
    },
    name: "OperatingReserveMultiNav"
  }])), [{
    path: "/EditProject/:propertyId",
    component: function component() {
      return import("pages/Project/EditProperty.vue");
    },
    name: "EditProperty",
    props: function props(r) {
      return {
        propertyId: r.params.propertyId,
        isNewProperty: false
      };
    }
  }, {
    path: "/todolist/property/:propertyId",
    component: function component() {
      return import("@/components/dashboard/PropertiesToDoList.vue");
    },
    name: "todolist",
    props: true
  }, {
    path: "/todolist/managementCompany/:managementCompanyId",
    component: function component() {
      return import("@/components/dashboard/PropertiesToDoList.vue");
    },
    name: "todolistMC",
    props: true
  }, {
    path: "/NewProject/:propertyId",
    component: function component() {
      return import("pages/Project/EditProperty.vue");
    },
    name: "NewProperty",
    props: function props(r) {
      return {
        propertyId: r.params.propertyId,
        isNewProperty: true
      };
    }
  }, {
    path: "/HousingPriorityCertificationList/:projectId",
    component: function component() {
      return import("pages/HousingPriorityCertification/HousingPriorityCertificationList.vue");
    },
    name: "HousingPriorityCertificationList",
    props: function props(r) {
      return {
        projectId: r.params.projectId
      };
    }
  }, {
    path: "/HousingPriorityCertificationProjectList",
    component: function component() {
      return import("pages/HousingPriorityCertification/HousingPriorityCertificationProjectList.vue");
    },
    name: "HousingPriorityCertificationProjectList"
  }, {
    path: "/HousingPriorityCertificationProjectListAdmin",
    component: function component() {
      return import("pages/HousingPriorityCertification/HousingPriorityCertificationProjectListAdmin.vue");
    },
    name: "HousingPriorityCertificationProjectListAdmin"
  }, {
    path: "/HousingPriorityCertification/create/:projectId",
    component: function component() {
      return import("pages/HousingPriorityCertification/HousingPriorityCertification.vue");
    },
    name: "CreateHousingPriorityCertification",
    props: function props(r) {
      return {
        projectId: r.params.projectId,
        create: true,
        periodDate: r.params.periodDate
      };
    }
  }, {
    path: "/HousingPriorityCertification/edit/:housingPriorityCertificationId",
    component: function component() {
      return import("pages/HousingPriorityCertification/HousingPriorityCertification.vue");
    },
    name: "EditHousingPriorityCertification",
    props: function props(r) {
      return {
        housingPriorityCertificationId: r.params.housingPriorityCertificationId,
        create: false
      };
    }
  }, {
    path: "/BudgetWorksheet/:projectId/:budgetYear",
    component: function component() {
      return import("pages/Budget/BudgetWorksheet.vue");
    },
    name: "BudgetWorksheet",
    props: true
  }, {
    path: "/BudgetList/:id",
    component: function component() {
      return import("pages/Budget/BudgetList.vue");
    },
    name: "BudgetList"
  }, {
    path: "/BudgetListAdmin",
    component: function component() {
      return import("pages/Budget/BudgetListAdmin.vue");
    },
    name: "BudgetListAdmin"
  }, {
    path: "/BudgetProjectList/:id",
    component: function component() {
      return import("pages/Budget/BudgetProjectList.vue");
    },
    name: "BudgetProjectList"
  }, {
    path: "/BudgetProjectHeader/:id",
    component: function component() {
      return import("pages/Budget/BudgetProjectHeader.vue");
    },
    name: "BudgetProjectHeader"
  }], _toConsumableArray(withPrefixPermission("budget", "Budget", [{
    path: "/view/:projectId/:budgetYear",
    component: function component() {
      return import("pages/Budget/Budget.vue");
    },
    name: "Budget",
    props: true
  }, {
    path: "/list/project/:projectId",
    component: function component() {
      return import("pages/Budget/BudgetList.vue");
    },
    name: "BudgetListAlt",
    props: true
  }, {
    path: "/list/admin",
    component: function component() {
      return import("pages/Budget/BudgetListAdmin.vue");
    },
    name: "BudgetListAdminAlt"
  }, {
    path: "/list/user/:id",
    component: function component() {
      return import("pages/Budget/BudgetProjectList.vue");
    },
    name: "BudgetProjectUserList"
  }])), [{
    path: "/ResidentRelations/:id/:residentRelationsId",
    component: function component() {
      return import("pages/ResidentRelations/ResidentRelations.vue");
    },
    name: "ResidentRelations"
  }, {
    path: "/ResidentRelationsList/:projectId/:issueTypeFilter",
    component: function component() {
      return import("pages/ResidentRelations/ResidentRelationsList.vue");
    },
    name: "ResidentRelationsListFiltered",
    props: function props(_ref) {
      var params = _ref.params;
      return {
        projectId: params.projectId,
        issueTypeFilter: Number.parseInt(params.issueTypeFilter) || 0
      };
    }
  }, {
    path: "/ResidentRelationsList/:projectId",
    component: function component() {
      return import("pages/ResidentRelations/ResidentRelationsList.vue");
    },
    name: "ResidentRelationsList",
    props: true
  }, {
    path: "/ResidentRelationsProjectList",
    component: function component() {
      return import("pages/ResidentRelations/ResidentRelationsProjectList.vue");
    },
    name: "ResidentRelationsProjectList"
  }], _toConsumableArray(withPrefixPermission("insuranceclaim", "Insurance_Claim", [{
    path: "/view/:id/:projectId",
    component: function component() {
      return import("pages/InsuranceClaim/InsuranceClaim.vue");
    },
    name: "InsuranceClaim"
  }, {
    path: "/list/:projectId",
    component: function component() {
      return import("pages/InsuranceClaim/InsuranceClaimList.vue");
    },
    name: "InsuranceClaimList"
  }, {
    path: "/list",
    component: function component() {
      return import("pages/InsuranceClaim/InsuranceClaimMultiNav.vue");
    },
    name: "InsuranceClaimMultiNav"
  }])), _toConsumableArray(withPrefixPermission("complianceForms", "Compliance_Forms", [{
    path: "/multiNav",
    component: function component() {
      return import("pages/ComplianceForms/ComplianceFormMultiNav.vue");
    },
    name: "ComplianceFormMultiNav"
  }, {
    path: "/list/:projectId",
    component: function component() {
      return import("pages/ComplianceForms/ComplianceFormList.vue");
    },
    name: "ComplianceFormList",
    props: true
  }, {
    path: "/settings/:propertyId",
    component: function component() {
      return import("pages/ComplianceForms/ComplianceFormSettings.vue");
    },
    name: "ComplianceFormSettings",
    props: true
  }, {
    path: "/review/:projectExhibitId",
    component: function component() {
      return import("pages/ComplianceForms/ComplianceFormReview.vue");
    },
    name: "ComplianceFormReview",
    props: true
  }, {
    path: "/:projectId/:exhibitId",
    component: function component() {
      return import("pages/ComplianceForms/ComplianceForm.vue");
    },
    name: "ComplianceForm",
    props: true
  }])), _toConsumableArray(withPrefixPermission("contact", null, [{
    path: "/ContactChangeRequestList",
    component: function component() {
      return import("pages/Contact/ContactChangeRequestList.vue");
    },
    props: true,
    name: "ContactChangeRequestList"
  }, {
    path: "/ContactChangeRequestReview/:requestId",
    component: function component() {
      return import("pages/Contact/ContactChangeRequestReview.vue");
    },
    props: true,
    name: "ContactChangeRequestReview"
  }, {
    path: "/ChangeRequestContactListProperty/:propertyId",
    component: function component() {
      return import("pages/Contact/ContactChangeRequestList.vue");
    },
    props: true,
    name: "ChangeRequestContactList"
  }, {
    path: "/ContactBulkEdit/:propertyId",
    component: function component() {
      return import("pages/Contact/ContactChangeRequest.vue");
    },
    props: true,
    name: "ContactBulkEdit"
  }])), _toConsumableArray(withPrefixPermission("rentIncrease", "Rent_Increase", [{
    path: "/RentIncrease/:id/:headerId",
    component: function component() {
      return import("pages/RentIncrease/RentIncrease.vue");
    },
    name: "RentIncrease"
  }, {
    path: "/RentIncreaseMultiNav",
    component: function component() {
      return import("pages/RentIncrease/RentIncreaseMultiNav.vue");
    },
    name: "RentIncreaseMultiNav"
  }, {
    path: "/RentIncreaseList/:id",
    component: function component() {
      return import("pages/RentIncrease/RentIncreaseList.vue");
    },
    name: "RentIncreaseList"
  }, {
    path: "/ReviewWorksheet/:id",
    component: function component() {
      return import("pages/RentIncrease/ReviewWorksheet.vue");
    },
    name: "ReviewWorksheet"
  }, {
    path: "/ReviewTaxCredit/:id",
    component: function component() {
      return import("pages/RentIncrease/ReviewTaxCredit.vue");
    },
    name: "ReviewTaxCredit"
  }, {
    path: "/ReviewCashFlow/:id",
    component: function component() {
      return import("pages/RentIncrease/ReviewCashFlow.vue");
    },
    name: "ReviewCashFlow"
  }])), [{
    path: "/Projects",
    component: function component() {
      return import("pages/Project/ProjectList.vue");
    },
    props: true,
    name: "Projects"
  }, {
    path: "/User/:isNew/:user_id",
    component: function component() {
      return import("pages/admin/UserMC.vue");
    },
    props: true,
    name: "UserMC"
  }, {
    path: "/MHDCViewPermissions/:user_id",
    component: function component() {
      return import("pages/admin/MHDCViewPermissions.vue");
    },
    props: true,
    name: "MHDCViewPermissions"
  }, {
    path: "/VendorList",
    component: function component() {
      return import("pages/Vendor/VendorList.vue");
    },
    name: "VendorList"
  }, {
    path: "/FutureNonCompliance",
    component: function component() {
      return import("pages/NonCompliance/FutureNonCompliance.vue");
    },
    name: "FutureNonCompliance"
  }, {
    path: "/Developer/list",
    component: function component() {
      return import("pages/Developer/DeveloperList.vue");
    },
    name: "DeveloperList"
  }, {
    path: "reporting/OccupancyBy",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 1
      };
    },
    name: "OccupancyByReport"
  }, {
    path: "reporting/RentAnalysis",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 2
      };
    },
    name: "RentAnalysisReport"
  }, {
    path: "reporting/StatementAnalysis",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 3
      };
    },
    name: "StatementAnalysisReport"
  }, {
    path: "reporting/VacancyReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 4
      };
    },
    name: "VacancyReport"
  }, {
    path: "reporting/OccupancyByProperty",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 5
      };
    },
    name: "OccupancyByProperty"
  }, {
    path: "reporting/PropertyViewOccupancyByReport",
    component: function component() {
      return import("pages/Reporting/PropertyViewOccupancyByProperty.vue");
    },
    props: function props(r) {
      return {
        reportId: 5
      };
    },
    name: "OccupancyByProperty"
  }, {
    path: "reporting/PropertyViewOccupancyByReport/:projectId",
    component: function component() {
      return import("pages/Reporting/PropertyViewOccupancyByProperty.vue");
    },
    props: function props(r) {
      return {
        reportId: 5
      };
    },
    name: "OccupancyByProperty"
  }, {
    path: "reporting/CongressionalDistrict",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 6
      };
    },
    name: "CongressionalDistrict"
  }, {
    path: "reporting/FinancialReportCard",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 7
      };
    },
    name: "FinancialReportCard"
  }, {
    path: "reporting/SpecialNeeds",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 8
      };
    },
    name: "SpecialNeeds"
  }, {
    path: "reporting/RentIncreaseHistory",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 9
      };
    },
    name: "RentIncreaseHistory"
  }, {
    path: "reporting/NOIReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 10
      };
    },
    name: "NOIReport"
  }, {
    path: "reporting/EconomicOccupancyReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 11
      };
    },
    name: "EconomicOccupancyReport"
  }, {
    path: "reporting/AccountsPayableReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 12
      };
    },
    name: "AccountsPayableReport"
  }, {
    path: "reporting/OccupancySummaryReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 13
      };
    },
    name: "OccupancySummaryReport"
  }, {
    path: "reporting/CurrentLRAReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 14
      };
    },
    name: "CurrentLRAReport"
  }, {
    path: "reporting/ComplianceSummaryReport",
    component: function component() {
      return import("pages/Reporting/Report.vue");
    },
    props: function props(r) {
      return {
        reportId: 15
      };
    },
    name: "ComplianceSummaryReport"
  }, {
    path: "/Developer/view/:developerId",
    component: function component() {
      return import("pages/Developer/DeveloperView.vue");
    },
    props: true,
    name: "DeveloperView"
  }, {
    path: "/2013/Review/:propertyId",
    component: function component() {
      return import("pages/2013/Review.vue");
    },
    name: "2013Review",
    props: true
  }, {
    path: "/2013/EditDetails/:id",
    component: function component() {
      return import("pages/2013/EditDetails.vue");
    },
    name: "EditDetails",
    props: true
  }, {
    path: "/2013/List",
    component: function component() {
      return import("pages/2013/List.vue");
    },
    name: "List",
    props: true
  }, {
    path: "/2013/List/:selectedYear/:selectedStatus/:selectedType",
    component: function component() {
      return import("pages/2013/List.vue");
    },
    name: "List",
    props: true
  }, {
    path: "/2013/Import",
    component: function component() {
      return import("pages/2013/Import.vue");
    },
    name: "Import2013",
    props: true
  }, {
    path: "/McCertificationList",
    component: function component() {
      return import("pages/McCertification/McCertificationList.vue");
    },
    name: "McCertificationList",
    props: true
  }], _toConsumableArray(withPrefixPermission("equityFigures", "EquityFigures", [{
    path: "/EquityFiguresPropertyList",
    component: function component() {
      return import("pages/EquityFigures/EquityFiguresPropertyList.vue");
    },
    name: "EquityFiguresPropertyList"
  }])), _toConsumableArray(withPrefixPermission("inspection", "Inspection", [{
    path: "/view/edit/:inspectionId",
    component: function component() {
      return import("pages/Inspection/Inspection.vue");
    },
    name: "EditInspection",
    props: function props(r) {
      return {
        inspectionId: r.params.inspectionId
      };
    }
  }, {
    path: "/view/create/:projectId",
    component: function component() {
      return import("pages/Inspection/Inspection.vue");
    },
    name: "CreateInspection",
    props: function props(r) {
      return {
        projectId: r.params.projectId,
        create: true
      };
    }
  }, {
    path: "/list/:projectId",
    component: function component() {
      return import("pages/Inspection/InspectionList.vue");
    },
    name: "InspectionList",
    props: true
  }, {
    path: "/multiNav",
    component: function component() {
      return import("pages/Inspection/InspectionMultiNav.vue");
    },
    name: "InspectionMultiNav"
  }])), _toConsumableArray(withPrefixPermission("ahl", "AHL", [{
    path: "/approvedReport",
    component: function component() {
      return import("pages/AHL/AhlApprovedReport.vue");
    },
    name: "AhlApprovedReport"
  }, {
    path: "/ahlList/:propertyId",
    component: function component() {
      return import("pages/AHL/AhlList.vue");
    },
    name: "AhlList",
    props: function props(r) {
      return {
        propertyId: r.params.propertyId
      };
    }
  }, {
    path: "/ahlMultiNav",
    component: function component() {
      return import("pages/AHL/AhlMultiNav.vue");
    },
    name: "AhlMultiNav"
  }, {
    path: "/AhlAdminList",
    component: function component() {
      return import("pages/AHL/AhlAdminList.vue");
    },
    name: "AhlAdminList"
  }])), [{
    path: "/Configuration",
    component: function component() {
      return import("pages/admin/ApplicationConfiguration.vue");
    },
    name: "ApplicationConfiguration"
  }, {
    path: "/EquityFigures",
    component: function component() {
      return import("pages/EquityFigures/EquityFigures.vue");
    },
    name: "EquityFigures"
  }, {
    path: "/LoanAdministration",
    component: function component() {
      return import("pages/EquityFigures/LoanAdministration.vue");
    },
    name: "LoanAdministration"
  }])
}, {
  path: "/",
  component: function component() {
    return import("layouts/LoggedOutLayout.vue");
  },
  children: [{
    path: "/login/:returnUrl?",
    component: function component() {
      return import("pages/login/Login.vue");
    },
    name: "login",
    props: true
  }, {
    path: "/forgotPassword",
    component: function component() {
      return import("pages/login/ForgotPassword.vue");
    },
    name: "forgotPassword"
  }, {
    path: "/resetPassword",
    component: function component() {
      return import("pages/login/ResetPassword.vue");
    },
    name: "resetPassword"
  }, {
    path: "/InputSamples",
    component: function component() {
      return import("pages/InputSamples.vue");
    },
    name: "InputSamples"
  }, {
    path: "/GridSample",
    component: function component() {
      return import("pages/GridSample.vue");
    },
    name: "GridSample"
  }, {
    path: "/CertifiedManagementCompanyAgentList",
    component: function component() {
      return import("pages/ManagementCompanies/CertifiedManagementCompanyAgentList.vue");
    },
    name: "CertifiedManagementCompanyAgentList"
  }]
}]; // Always leave this as last one

if (process.env.MODE !== "ssr") {
  routes.push({
    path: "*",
    component: function component() {
      return import("pages/Error404.vue");
    }
  });
}

export default routes;